import { useNavigate } from "react-router-dom";
import { useLogoutModel } from "../model/profileSection.model";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const useProfileSectionController = () => {
  const navigate = useNavigate();
  const model = useLogoutModel();

  const [loader, setLoader] = useState(false);
  const [toastError, setToastError] = useState("");

  useEffect(() => {
    if (toastError) {
      toast.error(toastError, {
        autoClose: 5000,
      });
    }
    setToastError("");
  }, [toastError]);

  const AdminLogout = async () => {
    try {
      setLoader(true);
      const response: any = await model.adminLogout();
      console.log(response);

      if (response.success) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("login-credentials");
        navigate("/", { state: { successToastMessage: response.message } });
      } else {
        setToastError(response.message);
      }
      setLoader(false);
    } catch (error: any) {
      setToastError(error);
      setLoader(false);
    }
  };

  const UserLogout = async () => {
    try {
      setLoader(true);
      const response: any = await model.userLogout();

      if (response.success) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("login-credentials");
        navigate("/", { state: { successToastMessage: response.message } });
      } else {
        setToastError(response.message);
      }
      setLoader(false);
    } catch (error: any) {
      setToastError(error);
      setLoader(false);
    }
  };

  const handleLogout = (isAdminLogginIn: boolean) => {
    console.log(isAdminLogginIn);
    isAdminLogginIn ? AdminLogout() : UserLogout();
  };

  return {
    handleLogout,
    loader,
  };
};
